import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { CatalogoService } from '../../../../service/CatalogoService';
import * as generic from '../../../../components/Generico';
import { ClientePnService } from '../../../../service/trust/ClientePnService';
import { InformacionLaboral } from '../../../../models/trust/cliente/InformacionLaboral';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';
import { InputActividadEconomica } from '../../../../components/ui/Formularios/InputActividadEconomica';

export const InfoLaboral = ({ toast, id, cliente, permss, catalogos, handlePrev, handleNext, nuevoCliente, soloLectura }) => {

    const omodel = new InformacionLaboral();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, getValues, trigger } = useForm({ defaultValues, shouldTrim: true, shouldUnregister: true, mode: 'onTouched' });
    const clienteServicio = new ClientePnService();
    const catalogoService = new CatalogoService();
    const { inDrop, inText, inArea, inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuador, setEcuador] = useState(false);
    const [ecuadorCy, setEcuadorCy] = useState(false);
    const [ciudadesEmpresa, setCiudadesEmpresa] = useState([]);
    const [ciudadesCy, setCiudadesCy] = useState([]);
    const [tieneAnexos, setTieneAnexos] = useState(false);
    const [esCasado, setEsCasado] = useState(null);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.ec = catalogos?.ecuador;
        data.seccion = 'seccion2';
        data.estado_civil = esCasado;

        if (id == null) {
            clienteServicio.newCliente(data).then(res => {
                nuevoCliente(res.data);
                generic.funcSuccess(res, toast);
                handleNext();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => setIsSaving(false));
        } else {
            data.id = id;
            clienteServicio.editarCliente(data).then(res => {
                nuevoCliente(res.data);
                generic.funcSuccess(res, toast);
                handleNext();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => setIsSaving(false));
        }
    }

    const editFicha = () => {
        setIsLoading(true);
        clienteServicio.consultarCliente(id ?? 0, { seccion: 'seccion2' }).then(res => {
            const cats = catalogos;
            const _cli = res.data.cliente;
            setTieneAnexos(res.data.tiene_anexos || false);
            if (!_cli) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }
            setEsCasado(_cli.estado_civil);
            if (res.data.ciudades_empresa) setCiudadesEmpresa(res.data.ciudades_empresa);
            if (res.data.ciudades_cy) setCiudadesCy(res.data.ciudades_cy);
            setEcuador(_cli.pais_empresa?.cat_id === cats?.ecuador?.cat_id);
            setEcuadorCy(_cli.pais_cy?.cat_id === cats?.ecuador?.cat_id);

            nuevoCliente({ id: _cli.id, nemonico: _cli.nemonico });
            reset(generic.renewValues(_cli, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePais = (e, esDeclarante) => {
        if (esDeclarante) {
            setEcuador(e.value?.cat_id === catalogos?.ecuador?.cat_id);
            setValue('provincia_empresa', null);
            setValue('ciudad_empresa', null);
            setCiudadesEmpresa([]);
            if (getValues('telefono_empresa')) {
                trigger('telefono_empresa');
            }
            if (getValues('celular_empresa')) {
                trigger('celular_empresa');
            }
        } else {
            setEcuadorCy(e.value?.cat_id === catalogos?.ecuador?.cat_id);
            setValue('provincia_cy', null);
            setValue('ciudad_cy', null);
            setCiudadesCy([]);
            if (getValues('telefono_cy')) {
                trigger('telefono_cy');
            }
            if (getValues('celular_cy')) {
                trigger('celular_cy');
            }
        }
    }

    const onChangeProvincia = (e, esDeclarante) => {
        if (esDeclarante) {
            setValue('ciudad_empresa', null);
            if (!e?.value) { setCiudadesEmpresa([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesEmpresa(res.data));
        } else {
            setValue('ciudad_cy', null);
            if (!e?.value) { setCiudadesCy([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesCy(res.data));
        }
    }

    const tipoDoc = 'IDEN_RUC';

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `RUC incorrecto`;
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

            <Panel header={generic.renderPanelHeader('B', 'TIPO DE VINCULACIÓN', 'pi pi-link')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDrop('tipo_vinculacion', catalogos?.tipo_vinculacion, { lab: omodel.optionLabel }, 12)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('C', 'INFORMACIÓN LABORAL', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">

                    {inDrop('tipo_relacion_laboral', catalogos?.tipo_relacion_laboral, {
                        lab: omodel.optionLabel,
                        ne: tieneAnexos ? true : undefined,
                        helpText: tieneAnexos ? "Para modificar el tipo de relación laboral, primero debe eliminar los anexos guardados en la Sección 5." : null
                    }, 4)}
                    {inText('nombre_empresa', { icon: 'pi pi-building' }, 4)}
                    {inText('ruc_empresa', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 4)}
                    {inText('cargo_empresa', { icon: 'pi pi-user-edit' }, 6)}
                    {inNumber('ingreso_mensual', 2, true, {}, 6)}
                    <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />

                    {inDrop('pais_empresa', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: true }, ecuador ? 4 : 6)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia_empresa', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: true }, 4)}
                            {inDrop('ciudad_empresa', ciudadesEmpresa, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_empresa', { icon: 'pi pi-map-marker' }, 6)
                    )}

                    {inArea('direccion_empresa', 3, 100, 12)}
                    {inText('telefono_empresa', { icon: 'pi pi-phone', validate: generic.validarTelefonoDinamico(getValues, 'pais_empresa') }, 4)}
                    {inText('celular_empresa', { icon: 'pi pi-mobile', validate: generic.validarTelefonoDinamico(getValues, 'pais_empresa') }, 4)}
                    {inText('email_empresa', { icon: 'pi pi-envelope', pattern: generic.VALIDACION_EMAIL }, 4)}
                </div>
            </Panel>

            {esCasado && (
                <Panel header={generic.renderPanelHeader('D', 'INFORMACIÓN LABORAL DEL CÓNYUGE', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        {inDrop('tipo_relacion_laboral_cy', catalogos?.tipo_relacion_laboral, { lab: omodel.optionLabel }, 6)}
                        {inText('empresa_cy', { icon: 'pi pi-building' }, 6)}
                        {inText('cargo_cy', { icon: 'pi pi-user-edit' }, 6)}
                        {inNumber('ingreso_mensual_cy', 2, true, {}, 6)}
                        <InputActividadEconomica name="actividad_economica_cy" control={control} modelDef={omodel.model['actividad_economica_cy']} disabled={soloLectura} col={12} />
                        {inDrop('pais_cy', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, ecuadorCy ? 4 : 6)}
                        {ecuadorCy ? (
                            <>
                                {inDrop('provincia_cy', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 4)}
                                {inDrop('ciudad_cy', ciudadesCy, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('canton_cy', { icon: 'pi pi-map-marker' }, 6)
                        )}
                        {inArea('direccion_cy', 3, 100, 12)}
                        {inText('telefono_cy', { icon: 'pi pi-phone', validate: generic.validarTelefonoDinamico(getValues, 'pais_cy') }, 4)}
                        {inText('celular_cy', { icon: 'pi pi-mobile', validate: generic.validarTelefonoDinamico(getValues, 'pais_cy') }, 4)}
                        {inText('email_cy', { icon: 'pi pi-envelope', pattern: generic.VALIDACION_EMAIL }, 4)}
                    </div>
                </Panel>
            )}

            <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
